import React,{useState, useEffect} from 'react';
import * as dbServices from "../../utils/dbServices";
import CsrProfileRegular from './csrProfileRegular';
import styles from '../../common/spinnerER.css'
import { useData } from '../../dataContext';


const CsrSPLMain = (props)  =>{

    const[data, setData] = useState([])
    const[data2, setData2] = useState([])
    const [titleResuts, setTitleResults] = useState("All Service Providers")
    const[categories, setCategories] = useState([])
    const[spid, setSpid] = useState(-1)
    const[searchString, setSearchString] = useState("")
    const[isLoading, setIsLoading] = useState(true)
    const { dataAll } = useData();

    //data download & context save here
    useEffect(() => {
        if(dataAll){
            const temp  = dataAll["csr"]
            setCategories([...temp["categoriesFull"]])
            setData([...temp["data"]])
            setData2([...temp["data"]])
            setIsLoading(false)
        }
    },[dataAll])


    // external data import

    // useEffect(() => {
    //     getData();
    // },[])

    // const getData = async () =>{
    //     const temp = await dbServices.getCsrData()
    //     console.log(temp)
    //     setCategories([...temp["categoriesFull"]])
    //     setData([...temp["data"]])
    //     setData2([...temp["data"]])
    //     setIsLoading(false)
    // }

    // data transform 

    const getSP = (spid, data) => {
        if (spid==-1) return null
        return data.filter(x=>x["pkey"] == spid)[0]
    }

    const filterData = (filterType, filterParams) =>{

        //Filter by entire category --> get all items where category includes category

        //Filter by sub category --> 

        if (filterType==1){
            return data
        }

    }
    
    // event handlers

    const handleServicenameSelect = (e, pkey) =>{

        setSpid(pkey)
    }

    const handleSearchFieldChange = (e) =>{

        setSearchString(e.target.value)
    }

    const handleSearchFieldKeyDown = async (e) =>{

        if(e.key==='Enter') await handleSearch()
    }

    const handleSearch = async () =>{

        if (searchString==="") return

        setIsLoading(true)
        const searchResults = await dbServices.searchCSR(searchString)

        // filter data2
        let temp = []
        for (let cat of Object.keys(searchResults)){
            console.log(cat)
            const temp2 = data.filter(x=>x["cats"].includes(cat))
            console.log(temp2)
            temp = [...temp, ...temp2]
        }

        setData2([...temp])
        setIsLoading(false)
        setTitleResults("Search Results")      
    }

    const handleSelectLeftMenuItem = (e,x) =>{

        console.log(x["cat1"])
        console.log(x["cat"])

        let temp2 = []
        let title = x["cat"]
        if(x["cat2"]==0){
            title = x["cat1"]
            let temp = data.filter(y=>(y["cats"].some(z=>z.includes(x["cat"]))))
            console.log(temp)
            temp2 = temp.filter((item, index, self) =>
            index === self.findIndex((t) => t["pkey"] === item["pkey"]));

            temp2.sort((a,b)=>a["servicename"]>b["servicename"]?1:-1)

            console.log(temp2)
        }
        else{
            let temp = data.filter(y=>(y["cats"].includes(x["cat"])==true))
            temp2 = temp.filter((item, index, self) =>
            index === self.findIndex((t) => t["pkey"] === item["pkey"]));

            temp2.sort((a,b)=>a["servicename"]>b["servicename"]?1:-1)
            console.log(temp2)
        }

        setData2([...temp2])
        setSpid(-1)
        setTitleResults(title)
        


    }

    const getLeftMenu = () =>{

        //prep stuf

        if (categories.length==0) return null


        return(
            <>
                <br/>
                <br/>
                <div className="row">
                    <img className="mb-3" src="https://cloud-1de12d.becdn.net/media/iW=261&iH=56&oX=0&oY=0&cW=260&cH=56/126163781c08429997f2007c128dc609/1751.png" style={{width:"14.05vw", height:"6.14vh"}}/>
                </div>
                <div className="row" style={{height:"98vh", overflowY:"auto"}}>
                    <div className = "col-12 ml-2">
                    {categories.map((x,idx)=>(
                    (x["cat2"]==="0")?
                        <div className="row mt-4 mb-2 pl-2" style={{cursor:"pointer", fontWeight:"800", fontSize:"18px"}} onClick={e=>handleSelectLeftMenuItem(e,x)}>{x["cat1"]}</div>
                        :<div className="row mb-2 pl-4" style={{cursor:"pointer"}} onClick={e=>handleSelectLeftMenuItem(e,x)}>{x["cat2"]}</div>
                    ))}

                    </div>
                </div>

            </>
        )
    }

    const getHeader = () =>{
        return(
            <>
                <div className="row mt-4 mb-2" style={{fontFamily:"Futura"}}>
                    <h3>Contractor and Services Recommendations - Stephanie Land Signature Edition</h3>
                </div>
                <div className="row mb-4" style={{fontFamily:"Futura"}}>
                    <span>Updated October 2026. The CSCA does not endorse this list but merely offers it as a useful service to the community.</span>
                </div>
            </>
        )
    }

    const getSearchBar = () =>{
        return(
            <>
                <div className="row mb-4">
                    <div className="col-6">
                        <input style={{fontFamily:"Futura"}} className="form-control" type="text" id="searchField" placeholder="Search by Provider Name or Category" value={searchString} onChange={e=>handleSearchFieldChange(e)} onKeyDown={e=>handleSearchFieldKeyDown(e)}></input>
                    </div>
                    <div className="col-4">
                        <button style={{fontFamily:"Futura"}} className="form-control button btn-warning" onClick={e=>handleSearch(e)}>Search</button>
                    </div>
                </div>
            </>
        )
    }

    const getProviderList = (data) =>{

        if(isLoading) return(
            <>
                {/* <div className="row d-flex flex-column justify-content-center align-content-center" style={{height:600}}>
                    {LoadSpinner()}
                    <br/>
                    Obtaining data/search results...
                </div> */}
                <div className="row" style={{position:"relative"}}>
                    <div className="col-12">                    
                        <div className="spinner-overlayER">
                            <div className="spinner"/>
                        </div>
                        <br/>
                        <div className="row d-flex align-items-center justify-content-center">
                            <span>Obtaining data/search results</span>
                        </div>
                     </div>
               </div>
            </>
        )   
    
        if (data.length===0) return(<span>No data for this selection/search</span>)

        return(

            <>
                <div className = "row mb-4">
                    <span style={{fontWeight:700, fontSize:"1.5rem"}}>{titleResuts}</span>

                </div>
                <div className="col-12" style={{height:"65vh", overflowY:"auto"}}>
                    {data.map((x,idx)=>(
                        <div className = "row mb-4 pl-4">
                            <span onClick={e=>handleServicenameSelect(e,x["pkey"])} style={{cursor:"pointer", fontFamily:"Futura", fontSize:"1.2rem"}}>{x["servicename"]}</span>
                        </div>
                    ))}
                </div>
            </>

            // <>
            //     <table className='table'>
            //         <thead style={{background:"#000000", color:"#ffffff", fontFamily:"Futura"}}>
            //             <th>Category</th>
            //             <th>Service Name</th>
            //         </thead>
            //         <tbody>
            //             {data.map((x,idx)=>(
            //                 <tr onClick={e=>handleServicenameSelect(e,x["pkey"])} style={{cursor:"pointer", fontFamily:"Futura"}}>
            //                     <td>{x["category"]}</td>
            //                     <td>{x["servicename"]}</td>
            //                 </tr>
            //             ))}
            //         </tbody>
            //     </table>
            // </>            
        )
    }

    const sp = getSP(spid, data2)

    return(
        <div className="row">
            <div className = "col-2 mr-4" style={{background:"#000000", color:"#ffffff"}}>
                {getLeftMenu()}
            </div>
            <div className= "col-8 pl-4">
                {getHeader()}
                {getSearchBar()}
                <hr/>
                <div className="row mb-2">
                    <div className="col-6">
                        {getProviderList(data2)}
                    </div>
                    <div className = "col-6">
                        <CsrProfileRegular sp={sp} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CsrSPLMain;